import { render, staticRenderFns } from "./BaseListFlipTransition.vue?vue&type=template&id=411b7722&scoped=true&functional=true&"
import script from "./BaseListFlipTransition.vue?vue&type=script&lang=js&"
export * from "./BaseListFlipTransition.vue?vue&type=script&lang=js&"
import style0 from "./BaseListFlipTransition.vue?vue&type=style&index=0&id=411b7722&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../client_web_food_market/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "411b7722",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Administrator\\Desktop\\gtzn\\FreeGoShop\\client_web_food_market\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('411b7722', component.options)
    } else {
      api.rerender('411b7722', component.options)
    }
    module.hot.accept("./BaseListFlipTransition.vue?vue&type=template&id=411b7722&scoped=true&functional=true&", function () {
      api.rerender('411b7722', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "client_web_common/base_components/BaseListFlipTransition.vue"
export default component.exports